<template>
    <div class="text-center">
        <div class="success-badge mb-2">
            <v-icon color="white" size="40">mdi-check-bold</v-icon>
        </div>
        <h1 :class="this.$vuetify.breakpoint.smAndDown ? 'text-h5' : 'secondary--text text-h2'" class="mt-2">
            You're all set!
        </h1>
        <h3 class="secondary--text text-h5 font-weight-regular">
            Your Message IQ account has been created<span v-if="email"> for <strong>{{ email }}</strong></span>.
        </h3>

        <v-row justify="center" class="mt-6">
            <v-col cols="12" sm="10" md="9">
                <div class="next-steps-card text-left">
                    <h4 class="text-overline mb-6 next-steps-title">What happens next</h4>
                    <div class="next-step d-flex align-start">
                        <div class="next-step-icon">
                            <v-icon color="white" size="20">mdi-email-fast-outline</v-icon>
                        </div>
                        <div class="pb-7 next-step-body">
                            <div class="text-subtitle-1 font-weight-bold">Check your email</div>
                            <div class="secondary--text">
                                We're sending a Campaign Registration form to <strong v-if="email">{{ email }}</strong><span v-else>your inbox</span> - this is required before you can send text messages.
                            </div>
                        </div>
                    </div>
                    <div class="next-step d-flex align-start">
                        <div class="next-step-icon">
                            <v-icon color="white" size="20">mdi-file-document-edit-outline</v-icon>
                        </div>
                        <div class="pb-7 next-step-body">
                            <div class="text-subtitle-1 font-weight-bold">Submit the form</div>
                            <div class="secondary--text">
                                Fill out and submit the Campaign Registration form as soon as you can to avoid delays.
                            </div>
                        </div>
                    </div>
                    <div class="next-step d-flex align-start next-step-last">
                        <div class="next-step-icon">
                            <v-icon color="white" size="20">mdi-cellphone-check</v-icon>
                        </div>
                        <div class="next-step-body">
                            <div class="text-subtitle-1 font-weight-bold">Get your number and start sending</div>
                            <div class="secondary--text">
                                Once your campaign is approved, we'll provision your phone number automatically and you'll be ready to send messages.
                            </div>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-footer :app="this.$vuetify.breakpoint.smAndDown" padless class="px-0 bg-transparent">
            <v-container fluid class="pa-0">
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-card-actions class="d-flex justify-center px-0">
                            <v-btn x-large outlined color="primary" @click="goToLogin">
                                Log In to Message IQ
                            </v-btn>
                        </v-card-actions>
                    </v-col>
                </v-row>
            </v-container>
        </v-footer>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

// Where a signed-in Message IQ user lands after login. Matches the mapping used in
// src/guards/productRegGuard.js (goToConfigurationPage) for the MessageIQ product,
// since this signup flow is Message IQ specific.
const POST_LOGIN_LANDING_ROUTE = '/conversations';

export default {
    name: "Confirmation",
    computed: {
        ...mapGetters('messageIqSignup', { email: 'getEmail' })
    },
    methods: {
        goToLogin() {
            this.$auth.loginWithRedirect({
                login_hint: this.email,
                appState: { targetUrl: POST_LOGIN_LANDING_ROUTE }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.success-badge {
    width: 84px;
    height: 84px;
    margin: 0 auto;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(135deg, #0cc27e 0%, #03b374 100%);
    box-shadow: 0 10px 24px rgba(12, 194, 126, 0.35);
}

.next-steps-card {
    border-radius: 20px;
    padding: 32px 36px;
    background-color: #fff;
    box-shadow: 0 12px 32px rgba(34, 45, 96, 0.12);
}

.next-steps-title {
    letter-spacing: 1.5px;
    color: #ed0c87;
    font-weight: 700;
}

.next-step {
    position: relative;
}

.next-step-icon {
    position: relative;
    z-index: 1;
    flex: 0 0 40px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 20px;
    background-image: linear-gradient(135deg, #ed0c87 0%, #415a99 100%);
    box-shadow: 0 4px 10px rgba(237, 12, 135, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
}

// Connects each step's icon to the next one, timeline-style. Positioned on
// .next-step (not .next-step-icon) using top+bottom so it doesn't depend on
// knowing the row's height up front - it spans from just below this step's
// icon to the top of the next one, wherever that ends up being.
.next-step:not(.next-step-last) {
    &::after {
        content: "";
        position: absolute;
        top: 40px;
        bottom: 0;
        left: 19px;
        width: 2px;
        background-color: rgba(65, 90, 153, 0.15);
    }
}

.next-step-body {
    padding-top: 8px;
}
</style>
